import { render, staticRenderFns } from "./TableHeaderLabel.vue?vue&type=template&id=7b432bde&scoped=true"
import script from "./TableHeaderLabel.vue?vue&type=script&lang=js"
export * from "./TableHeaderLabel.vue?vue&type=script&lang=js"
import style0 from "./TableHeaderLabel.vue?vue&type=style&index=0&id=7b432bde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b432bde",
  null
  
)

export default component.exports